import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const FORM_URL = 'https://readdy.ai/api/form/d8r5nkte8ise6dlc8i7g';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const formData = new URLSearchParams();
      formData.append('email', email);
      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      if (!response.ok) throw new Error('Submission failed');
      setSubmitStatus('success');
      setEmail('');
    } catch {
      setSubmitStatus('error');
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-50 rounded-t-3xl mx-3 md:mx-6 mt-20">
      <div className="px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="text-xl md:text-2xl font-heading font-bold mb-4">
              LitBuy Spreadsheet Hub
            </h3>
            <p className="text-foreground-300 text-sm leading-relaxed">
              Your trusted resource for mastering spreadsheet-based buying management.
            </p>
          </div>

          <div>
            <h4 className="font-label font-semibold text-sm uppercase tracking-wide mb-4 text-background-50">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/what-is-litbuy-spreadsheet"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  Beginner Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label font-semibold text-sm uppercase tracking-wide mb-4 text-background-50">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/what-is-litbuy-spreadsheet" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  Beginner Guide
                </Link>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  Kaspreadsheet Store
                </a>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  litbuy spreadsheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label font-semibold text-sm uppercase tracking-wide mb-4 text-background-50">
              Stay Updated
            </h4>
            <p className="text-sm text-foreground-300 mb-3 leading-relaxed">
              Get the latest guides and tips delivered to your inbox.
            </p>
            <form onSubmit={handleNewsletter} data-readdy-form id="newsletter-form" className="flex">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                required
                className="flex-1 bg-foreground-800 text-background-50 text-sm px-4 py-2.5 rounded-l-full outline-none placeholder:text-foreground-400 border border-foreground-700 focus:border-primary-500 transition-colors"
              />
              <button
                type="submit"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-4 py-2.5 rounded-r-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </button>
            </form>
            {submitStatus === 'success' && (
              <p className="text-xs text-accent-400 mt-2">Thanks for subscribing!</p>
            )}
            {submitStatus === 'error' && (
              <p className="text-xs text-red-400 mt-2">Something went wrong. Please try again.</p>
            )}
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700/50 mx-6 md:px-12"></div>

      <div className="px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-foreground-400">
          &copy; {new Date().getFullYear()} LitBuy Spreadsheet Hub. All rights reserved.
        </p>
        <p className="text-xs text-foreground-400">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="hover:text-primary-400 transition-colors"
          >
            Visit Kaspreadsheet Store
          </a>
        </p>
      </div>
    </footer>
  );
}